module.exports = __webpack_public_path__ + "img/default_img6.16285053.webp";